export const BackendFiltersUrlKey = 'filters' as const;
